import { render, staticRenderFns } from "./OrderEInvoiceLockAlert.vue?vue&type=template&id=06d6cffa"
import script from "./OrderEInvoiceLockAlert.vue?vue&type=script&lang=js"
export * from "./OrderEInvoiceLockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports